import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ServidorRecad } from 'app/model/servidorRecad';
import { ToastrService } from 'ngx-toastr';
import { VinculosPosRecadDTO } from './vinculosPosRecad.dto';
import { ModalComponent } from 'app/components/modal/modal.component';
import {Observable} from "rxjs";
import {DadosPessoaisPosRecadDto} from "../aba1-posrecad/dadosPessoaisPosRecad.dto";
import {PosCampanhaServiceAba12} from "../../../service/posCampanhaAba12/pos-campanha-aba12.service";
import {MaskUtil} from "../../../utils/mask-util";


type DadosTabela = {
  descricao: string;
  informacaoSrh: string;
  informacaoRecad: string;
}


@Component({
  selector: 'app-aba12-posrecad',
  templateUrl: './aba12-posrecad.component.html',
  styleUrls: ['./aba12-posrecad.component.sass']
})
export class Aba12PosrecadComponent implements OnInit {
  @Input() servidor: ServidorRecad;
  @Output() flExibirTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() salvoOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() botoesDesabilitadosVinculos: EventEmitter<any> = new EventEmitter<any>();
  @Input() btnDesativadoVinculos: boolean;
  displayedColumns: string[] = ['descricao', 'informacaoSrh', 'informacaoRecad'];
  color: ThemePalette = 'primary';
  list: DadosTabela[] = [];

  dataSource: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  vinculosPosRecad: VinculosPosRecadDTO;
  salvo: boolean = false;
  panelOpenState = false;

  justificativa: string = '';
  isDisabledJustificativa: boolean = true

  constructor(private toasterService: ToastrService, public dialog: MatDialog, private posCampanhaServiceAba12: PosCampanhaServiceAba12) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.data = [];
    this.list = [];
    this.salvo = false;
    // this.justificativa = "";
    this.findVinculos(this.servidor.id);
  }

  findVinculos(recadServidorId: number) {
    this.getVinculos(recadServidorId).subscribe(
        response => {
          if(response){
            this.vinculosPosRecad = response
            this.vinculosPosRecad.listaSrh.map( i => {
              i.cpf ? i.cpf = MaskUtil.cpfToMask(i.cpf.toString()) : i.cnpj = MaskUtil.cnpjToMask(i.cnpj.toString())
            })
            this.vinculosPosRecad.listaRecad.map( i => {
              i.cpf ? i.cpf = MaskUtil.cpfToMask(i.cpf.toString()) : i.cnpj = MaskUtil.cnpjToMask(i.cnpj.toString())
            })
          } else {
            this.flExibirTab.emit(false);
          }
        },
        (error) => {
          console.error(error);
        }
    );
  }

  private getVinculos(recadServidorId: number): Observable<VinculosPosRecadDTO> {

    return this.posCampanhaServiceAba12.getObterVinculos(recadServidorId);
  }

  private montarDadosTabela(resp: VinculosPosRecadDTO): DadosTabela[] {
    this.list.push(
      {
        descricao: "Conselho",
        informacaoSrh:  'teste',
        informacaoRecad: 'teste',

      }
    );

    return this.list;
  }


  visualizarComprovante() { }


  openDialog(): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Justificativa',
        descricao: 'Justifique o motivo de recusa:',
        labelOne: 'Cancelar',
        labelTwo: 'Salvar',
        flTextArea: true,
        action: (justificativa: string) => {
          this.justificativa = justificativa;
          this.aprovar(3)
          this.botoesDesabilitadosVinculos.emit(true);
        }
      }
    });
  }

  rejeitar(){
    this.isDisabledJustificativa = false
    this.openDialog();
  }

  aprovar(status){
    /*
    status
    1- aceito
    2-pendente
    3- recusado
    * */
    this.botoesDesabilitadosVinculos.emit(true);
    if(status == 1){
      this.justificativa = ''
    }
    let body = {
      id: this.servidor.id,
      status: status,
      justificativa: this.justificativa,

    }
    this.posCampanhaServiceAba12.postVinculos(body).subscribe( resp => {
      this.toasterService.success("Dados salvos com sucesso");
      this.salvo = true;
      this.salvoOutput.emit(true);
    });
  }


}
